import { Action, MenuState, initialContextValue } from "../context/AppContext"
import { authConstants, menuConstants } from "../context/constants"

export const menuReducer = (state: MenuState, action: Action) => {
    try {
        switch (action.type) {
            case menuConstants.MENU_REQUEST:
                return {
                    ...state,
                    loading: true,
                    loaded: false,
                }
            case menuConstants.MENU_SUCCESS:
                return {
                    ...action.payload.permisos,
                    loading: false,
                    loaded: true
                }
            case menuConstants.MENU_FAILURE:
                return {
                    loading: false,
                    loaded: false,
                    error: action.payload
                }
            case authConstants.LOGOUT:
                return {
                    loaded: false,
                    loading: false
                }
            default:
                return state;
        }
    } catch (err) {
        localStorage.removeItem("persistma");
        return initialContextValue;
    }
}